import { render } from "./EmployeeAvatar.vue?vue&type=template&id=9235ebb0"
import script from "./EmployeeAvatar.vue?vue&type=script&lang=ts"
export * from "./EmployeeAvatar.vue?vue&type=script&lang=ts"
script.render = render

export default script